import { useToggle } from 'hooks/useToggle';
import { FC } from 'react';
import type { RenderPropChildren } from 'types/children';

export type WithToggleProps = Readonly<{
  isInitiallyOn?: boolean;
}>;

export type WithToggleChildrenProps = Readonly<{
  isOn: boolean;
  toggle(): void;
  toggleOn(): void;
  toggleOff(): void;
}>;

export const WithToggle: FC<RenderPropChildren<WithToggleChildrenProps> & WithToggleProps> = ({
  isInitiallyOn,
  children,
}) => {
  const toggleProps = useToggle(isInitiallyOn);

  return <>{children(toggleProps)}</>;
};
